// «Сильные стороны и ресурсы» — design workspace screen (pwa-design@insights)
// on the engine strengths: numbered cards. Hide (§2.8 rule 8) applies.

import { useInsightsData } from '../model/useInsightsData'
import InsightsGate from './InsightsGate'
import InsightsEmpty from './InsightsEmpty'
import InsightsTabBar from './InsightsTabBar'
import HideButton from './HideButton'
import styles from './NumberedCards.module.css'
import { BEFORE_PAYMENT_EMPTY } from './beforePaymentCopy'

const GROWS_NOTE = 'Раздел будет дополняться автоматически после ваших следующих разговоров'

export default function Strengths() {
  const insights = useInsightsData()
  return (
    <>
      <InsightsGate insights={insights}>
        {insights.data && (
          <div className={styles.page}>
            <h1 className={styles.title}>Сильные стороны и ресурсы</h1>
            <p className={styles.lead}>Что проявилось в ваших разговорах.</p>
            {insights.data.strengths.length === 0 ? (
              <InsightsEmpty
                title="Здесь пока пусто"
                text={insights.data.before_payment ? BEFORE_PAYMENT_EMPTY.strengths : 'Начните диалог с AI-психологом, и здесь появятся сильные стороны и ресурсы, которые проявляются в ваших разговорах.'}
              />
            ) : (
              <ol className={styles.list}>
                {insights.data.strengths.map((item, index) => (
                  <li key={item.id} className={styles.card}>
                    <span className={styles.index} aria-hidden="true">{`${String(index + 1).padStart(2, '0')}.`}</span>
                    <div className={styles.body}>
                      <h2 className={styles.cardTitle}>{item.title}</h2>
                      <p className={styles.cardText}>{item.text}</p>
                    </div>
                    <HideButton
                      onHide={() => { void insights.hide('strengths', item.id) }}
                      busy={insights.hiding === `strengths/${item.id}`}
                    />
                  </li>
                ))}
              </ol>
            )}
            {insights.data.notes.strengths_grows && insights.data.strengths.length > 0 && (
              <p className={styles.growsNote}>{GROWS_NOTE}</p>
            )}
          </div>
        )}
      </InsightsGate>
      <InsightsTabBar />
    </>
  )
}
